import React,{useState} from "react";
import { Route, Routes, useLocation, Navigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

import Sidebar from "./components/sidebar";
import SidebarLight from './components/sidebarLight'
import Switcher from "./components/switcher";
import Topnav from "./components/topnav";
import Footer from "./components/footer";
import SidebarColored from "./components/sidebarColored";

import Index from "./pages/index";
import IndexDark from "./pages/Layouts/index-dark";
import IndexRtl from "./pages/Layouts/index-rtl";
import IndexDarkRtl from "./pages/Layouts/index-dark-rtl";
import IndexSidebarLight from "./pages/Layouts/index-sidebar-light";
import IndexSidebarColored from "./pages/Layouts/index-sidebar-colored";
import Chat from "./pages/Apps/chat";
import Email from "./pages/Apps/email";
import Calendar from "./pages/Apps/calendar";
import Profile from "./pages/User-Profile/profile";
import ProfileBilling from "./pages/User-Profile/profile-billing";
import ProfilePayments from "./pages/User-Profile/profile-payment";
import ProfileSocial from "./pages/User-Profile/profile-social";
import ProfileNotification from "./pages/User-Profile/profile-notification";
import ProfileSetting from "./pages/User-Profile/profile-setting";
import Blogs from "./pages/Blog/blogs";
import BlogDetails from "./pages/Blog/blog-detail";
import Shop from "./pages/Ecommerce/shop";
import ShopItemDetails from "./pages/Ecommerce/shop-item-detail";
import ShopCart from "./pages/Ecommerce/shop-cart";
import Checkout from "./pages/Ecommerce/checkout";
import GalleryOne from "./pages/Gallery/gallery-one";
import Gallerytwo from "./pages/Gallery/workflow-library";
import Starter from "./pages/pages/starter";
import Faqs from "./pages/pages/faqs";
import Pricing from "./pages/pages/pricing";
import Team from "./pages/pages/team";
import Privacy from "./pages/pages/privacy";
import Terms from "./pages/pages/terms";
import UiComponents from "./pages/ui-components";
import Blank from "./pages/blank";
import HighIntentLeads from "./pages/HighIntentLeads";
import Outbound from "./pages/Outbound";
import Outbound2 from "./pages/Outbound2";
import WorkflowBuilder from "./pages/workflow-builder";
import EmailConfirmation from "./pages/Email-template/email-confirmation";
import PasswordReset from "./pages/Email-template/email-password-reset";
import EmailAlert from "./pages/Email-template/email-alert";
import EmailInvoice from "./pages/Email-template/email-invoices";
import InvoiceList from "./pages/invoice/invoice-list";
import InvoicePrivew from "./pages/invoice/invoice";
import AuthLogin from "./pages/Authentication/auth-login";
import Signup from "./pages/Authentication/auth-signup";
import AuthSignupSuccess from "./pages/Authentication/auth-signup-success";
import AuthResetPassword from "./pages/Authentication/auth-re-password";
import AuthLockScreen from "./pages/Authentication/auth-lock-screen";
import Comingsoon from "./pages/Miscellaneous/comingsoon";
import Maintenance from "./pages/Miscellaneous/maintenance";
import PageError from "./pages/Miscellaneous/error";
import PageThankyou from "./pages/Miscellaneous/thankyou";
import IndexCrypto from "./pages/index-crypto";


function App() {
  const[toggle, setToggle] = useState(true)
  let location = useLocation();

  const { isAuthenticated, isLoading } = useAuth0();

  const isPublicPath = ["/email-confirmation", "/email-password-reset", "/email-alert", "/email-invoices", "/auth-login", "/auth-signup", "/auth-signup-success", "/auth-re-password", "/auth-lock-screen", "/comingsoon", "/maintenance", "/error", "/thankyou"].includes(location.pathname);

  // Parse the query parameters. hasCodeAndState means redirecting before the user fully logged in and isAuthenticated
  const searchParams = new URLSearchParams(location.search);
  const hasCodeAndState = searchParams.has('code') && searchParams.has('state');
  

  // Redirect to /login if not authenticated
  if (!isAuthenticated && !isLoading && !isPublicPath && !hasCodeAndState) {
    return <Navigate to="/auth-login" replace />;
  }
  

  return (
    <>
    {location.pathname === "/email-confirmation" || location.pathname === "/email-password-reset" || location.pathname === "/email-alert" || location.pathname === "/email-invoices" || location.pathname === "/auth-login" || location.pathname === "/auth-signup" || location.pathname === "/auth-signup-success" || location.pathname === "/auth-re-password" || location.pathname === "/auth-lock-screen"  || location.pathname === "/comingsoon" || location.pathname === "/maintenance" || location.pathname === "/error" || location.pathname === "/thankyou" ?  
      <Routes>
        <Route path="/email-confirmation" element={<EmailConfirmation/>}/>
        <Route path="/email-password-reset" element={<PasswordReset/>}/>
        <Route path="/email-alert" element={<EmailAlert/>}/>
        <Route path="/email-invoices" element={<EmailInvoice/>}/>
        <Route path="/auth-login" element={<AuthLogin/>}/>
        <Route path="/auth-signup" element={<Signup/>}/>
        <Route path="/auth-signup-success" element={<AuthSignupSuccess/>}/>
        <Route path="/auth-re-password" element={ <AuthResetPassword/>}/>
        <Route path="/auth-lock-screen" element={ <AuthLockScreen/>}/>
        <Route path="/comingsoon" element={<Comingsoon/>}/>
        <Route path="/maintenance" element={<Maintenance/>}/>
        <Route path="/error" element={ <PageError/>}/>
        <Route path="/error" element={ <PageError/>}/>
        <Route path="/thankyou" element={ <PageThankyou/>}/>
      </Routes> : 
      <div className={`page-wrapper  ${toggle ? "toggled" : ""}`}>
        {location.pathname === '/index-sidebar-light' ? <SidebarLight/> : location.pathname === '/index-sidebar-colored' ? <SidebarColored/> : location.pathname === '/email-confirmation' ? "" : <Sidebar />}
          <main className="page-content bg-gray-50 dark:bg-slate-800">
              <Topnav toggle={toggle} setToggle={setToggle}/>
              <Routes>
                <Route exact path="/" element={<Index/>}/>
                <Route path="/index" element={<Index/>}/>
                <Route path="/index-crypto" element={<IndexCrypto/>}/>
                <Route path="/index-dark" element={<IndexDark/>}/>
                <Route path="/index-rtl" element={<IndexRtl/>}/>
                <Route path="/index-dark-rtl" element={<IndexDarkRtl/>}/>
                <Route path="/index-sidebar-light" element={<IndexSidebarLight/>}/>
                <Route path="/index-sidebar-colored" element={<IndexSidebarColored/>}/>
                <Route path="/chat" element={<Chat/>}/>
                <Route path="/email" element={<Email/>}/>
                <Route path="/calendar" element={<Calendar/>}/>
                <Route path="/profile" element={<Profile/>}/>
                <Route path="/profile-billing" element={<ProfileBilling/>}/>
                <Route path="/profile-payment" element={<ProfilePayments/>}/>
                <Route path="/profile-social" element={<ProfileSocial/>}/>
                <Route path="/profile-notification" element={<ProfileNotification/>}/>
                <Route path="/profile-setting" element={<ProfileSetting/>}/>
                <Route path="/blog" element={<Blogs/>}/>
                <Route path="/blog-detail" element={<BlogDetails/>}/>
                <Route path="/blog-detail/:id" element={<BlogDetails/>}/>
                <Route path="/shop" element={<Shop/>}/>
                <Route path="/shop-item-detail" element={<ShopItemDetails/>}/>
                <Route path="/shop-item-detail/:id" element={<ShopItemDetails/>}/>
                <Route path="/shop-cart" element={<ShopCart/>}/>
                <Route path="/checkout" element={<Checkout/>}/>
                <Route path="/gallery-one" element={<GalleryOne/>}/>
                <Route path="/workflow-library" element={<Gallerytwo/>}/>
                <Route path="/starter" element={<Starter/>}/>
                <Route path="/faqs" element={<Faqs/>}/>
                <Route path="/pricing" element={<Pricing/>}/>
                <Route path="/team" element={<Team/>}/>
                <Route path="/privacy" element={<Privacy/>}/>
                <Route path="/terms" element={<Terms/>}/>
                <Route path="/ui-components" element={<UiComponents/>}/>
                <Route path="/blank" element={<Blank/>}/>
                <Route path="/high-intent-leads" element={<HighIntentLeads/>}/>
                <Route path="/outbound" element={<Outbound/>}/>
                <Route path="/outbound2" element={<Outbound2/>}/>
                <Route path="/workflow-builder" element={<WorkflowBuilder/>}/>
                <Route path="/invoice-list" element={<InvoiceList/>}/>
                <Route path="/invoice" element={<InvoicePrivew/>}/>
                
              </Routes>
              <Footer/>
          </main>
          <Switcher/>
      </div>
      }
    </>
    
  );
}

export default App;
